export default __webpack_public_path__ + "locales/lv/Ldap.json?hash=86841de3c9fcb9130b6255f8a7edbded";